<template>
  <b-sidebar
    v-if="sidebarWidth !== ''"
    id="spec-minimal-price-sidebar"
    bg-variant="white"
    right
    lazy
    backdrop
    no-header
    no-close-on-backdrop
    @shown="getData"
    @hidden="resetSidebarData"
    shadow
    :width="sidebarWidth"
    ref="minimalPriceSidebar"
    :title="addPrice ? 'Добавление тарифа Минимальный' : 'Редактирование тарифа Минимальный'">
    <template v-slot:default="{ hide }">
      <b-container fluid>
        <b-button-close @click="hide()"></b-button-close>
        <b-form @submit.stop.prevent="saveFormData" autocomplete="off">
          <h2 v-if="addPrice" class="my-4">Добавление тарифа Минимальный</h2>
          <h2 v-else class="my-4">Редактирование тарифа Минимальный</h2>
          <b-row>
            <b-col md="3">
              <b-form-group
                label="Организация"
                label-for="dealerClient"
                label-class="mf-label"
                :invalid-feedback="getError('dealer')"
              >
                <treeselect
                  id="dealerClient"
                  name="dealerClient"
                  :options="dealerClientsFiltered"
                  v-model="clientsModel"
                  noResultsText="Ничего не найдено..."
                  :clearable=true
                  placeholder="Выбрать..."
                  label="Организация"
                  :disabled="disabled || !addPrice"
                  data-vv-as="Организация"
                  v-validate="{required:true}"
                >
                  <div slot="value-label" slot-scope="{ node }">{{ node.raw.name }}</div>
                </treeselect>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Дата"
                label-for="dateStart"
                label-class="mf-label"
              >
                <a-date-picker
                  id="dateStart-specialMinimalPrice"
                  v-model="dateStart"
                  :disabled="disabled"
                  format="DD/MM/YYYY"
                  placeholder="Дата"/>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col md="3">
              <b-form-group
                label="% вознаграждения"
                label-for="percentCompensation-input"
                label-class="mf-label"
                :invalid-feedback="getError('% вознаграждения')"
                style="margin-bottom: 0">
                <b-form-input
                  id="percentCompensation-input"
                  name="% вознаграждения"
                  v-validate="priceValidation"
                  data-vv-as="% вознаграждения"
                  v-model="percentCompensation"
                  :disabled="disabled"
                  :state="validateState('% вознаграждения')"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Стоимость"
                label-for="priceDefault-input"
                label-class="mf-label"
                :invalid-feedback="getError('Стоимость')"
                style="margin-bottom: 0">
                <b-form-input
                  id="priceDefault-input"
                  name="Стоимость"
                  v-validate="priceValidation"
                  data-vv-as="Стоимость"
                  v-model="priceDefault"
                  :disabled="disabled"
                  :state="validateState('Стоимость')"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Вознаграждение"
                label-for="priceRecalc-input"
                label-class="mf-label"
                :invalid-feedback="getError('Вознаграждение')"
                style="margin-bottom: 0">
                <b-form-input
                  id="priceRecalc-input"
                  name="Вознаграждение"
                  v-validate="priceValidation"
                  data-vv-as="Вознаграждение"
                  v-model="priceRecalc"
                  :disabled="disabled"
                  :state="validateState('Вознаграждение')"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="1" class="d-flex align-items-end">
              <b-button :disabled="disabled" @click="recalcPrices" variant="outline-primary" v-b-tooltip title="Рассчитать"><i class="fas fa-calculator"></i></b-button>
            </b-col>
          </b-row>
          <hr />
          <b-row class="mb-4 mt-3">
            <b-col md="6">
              <b-form-group
                label="Email"
                label-for="emails-input"
                label-class="mf-label"
                :invalid-feedback="getError('Emails')"
                style="margin-bottom: 0">
                <b-form-input
                  id="emails-input"
                  name="Email"
                  v-validate="modelValidation.emails"
                  data-vv-as="Emails"
                  v-model="emails"
                  :disabled="disabled"
                  :state="validateState('Emails')"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-3 mt-3">
            <b-col xl="6" lg="12" md="12" sm="12" cols="12">
              <div class="d-md-flex d-lg-flex align-items-start">
                <b-button
                  :disabled="veeErrors.any() || (Boolean(dateStart) === false) || disabled"
                  variant="success"
                  type="submit"
                  class="btn-action-success mr-3 mb-2">
                  <span v-if="addPrice">Добавить тариф</span>
                  <span v-else>Изменить тариф</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
    </template>
  </b-sidebar>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { validation } from '../modalForms/validation'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moment from 'moment'

export default {
  name: 'AddSpecialMinimalPrice',
  components: {
    Treeselect
  },
  props: ['addPrice', 'disabled', 'clientOrgId', 'dealerOrgId'],
  mixins: [validation],
  data () {
    return {
      sidebarWidth: '',
      dateStart: null,
      emails: null,
      clientsModel: null,
      percentCompensation: null,
      priceDefault: null,
      priceRecalc: null
    }
  },
  mounted () {
    this.calcSidebarWidth()
  },
  computed: {
    ...mapState(
      {
        mobile: state => state.mobile,
        tablet: state => state.tablet,
        desktop: state => state.desktop,
        largeDesktop: state => state.largeDesktop,
        dealerPriceData: state => state.dealers.dealerPriceData,
        dealerClients: state => state.dealers.dealerClients
      }
    ),
    dealerClientsFiltered () {
      return this.dealerClients ? this.dealerClients.map((item) => ({ ...item, id: item.org_id })) : []
    }
  },
  methods: {
    percentage (percent, total) {
      return ((percent / 100) * total).toFixed(2)
    },
    recalcPrices () {
      this.priceRecalc = parseFloat(this.percentage(this.percentCompensation, this.priceDefault))
    },
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    calcSidebarWidth () {
      if (this.largeDesktop) {
        this.sidebarWidth = '50%'
      } else if (this.desktop) {
        this.sidebarWidth = '100%'
      } else if (this.mobile || this.tablet) {
        this.sidebarWidth = '100%'
      }
    },
    resetSidebarData () {
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.resume()
      })
      setTimeout(() => {
        this.dateStart = null
        this.clientsModel = null
        this.percentCompensation = null
        this.priceDefault = null
        this.priceRecalc = null
        this.setPrice(null)
      }, 200)
    },
    getData () {
      this.getDealerClients({ id: this.$route.params.id })
      if (!this.addPrice) {
        this.clientsModel = this.clientOrgId
        this.getDealerMinimalPrice({ client_org_id: this.clientOrgId, dealer_org_id: this.dealerOrgId }).then(
          () => {
            this.dateStart = moment(this.dealerPriceData.start_date)
            this.priceDefault = this.dealerPriceData.tariff_compensation
            this.priceRecalc = this.dealerPriceData.tariff_cost
            this.emails = this.dealerPriceData.emails
            this.calcPackagesPercent()
          }
        )
      }
    },
    calcPackagesPercent () {
      this.percentCompensation = (this.dealerPriceData.tariff_cost * 100 / this.dealerPriceData.tariff_compensation).toFixed(2)
    },
    saveFormData () {
      const data = {
        client_org_id: this.clientsModel,
        start_date: this.dateStart,
        dealer_org_id: this.dealerOrgId,
        package_count: 10,
        compensation: parseFloat(this.priceDefault),
        cost: parseFloat(this.priceRecalc),
        emails: this.emails.split(',')
      }
      if (this.addPrice) {
        this.saveDealerMinimumPrice(data).then(
          () => {
            this.getDealerSpecialPrices({ id: this.$route.params.id })
            this.getDealerMinimalPrices({ org_id: this.dealerOrgId })
            this.$refs.minimalPriceSidebar.hide()
          }
        )
      } else {
        this.updateDealerMinimumPrice({ tariff_id: this.dealerPriceData.tariff_id, params: data }).then(
          () => {
            this.getDealerSpecialPrices({ id: this.$route.params.id })
            this.getDealerMinimalPrices({ org_id: this.dealerOrgId })
            this.$refs.minimalPriceSidebar.hide()
          }
        )
      }
    },
    ...mapActions('dealers', [
      'getDealerClients',
      'saveDealerMinimumPrice',
      'updateDealerMinimumPrice',
      'getDealerSpecialPrices',
      'getDealerMinimalPrices',
      'getDealerMinimalPrice'
    ]),
    ...mapMutations('dealers', [
      'setPrice'
    ])
  }
}
</script>

<style scoped>
  .form-control:disabled {
      background-color: #f5f5f5;
  }
</style>
